module.exports = __webpack_public_path__ + "static/media/ajustes112.13b7ebf7.png";